module.exports = __webpack_public_path__ + "img/Mockup2.3fcea945.webp";